import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import React from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import ActionButton from '@arcblock/ux/lib/ActionButton';
import Alert from '@arcblock/ux/lib/Alert';
import Badge from '@arcblock/ux/lib/Badge';
import ContactForm from '@arcblock/ux/lib/ContactForm';
import Countdown from '@arcblock/ux/lib/CountDown';
import Tag from '@arcblock/ux/lib/Tag';
import AsyncComponent from '@arcblock/ux/lib/Async';
import Typography from '@material-ui/core/Typography';
import ContentIcon from '../../components/icon';
var Video = AsyncComponent(function () {
  return import('@arcblock/ux/lib/Video');
});
var ClickToCopy = AsyncComponent(function () {
  return import('@arcblock/ux/lib/ClickToCopy');
});
var Screenshot = AsyncComponent(function () {
  return import('@arcblock/ux/lib/Screenshot');
});
var WalletDownload = AsyncComponent(function () {
  return import('@arcblock/ux/lib/Wallet/Download');
});
var WalletAction = AsyncComponent(function () {
  return import('@arcblock/ux/lib/Wallet/Action');
});
var PlaygroundAction = AsyncComponent(function () {
  return import('@arcblock/did-playground/lib/Action');
});
var LoginProtected = AsyncComponent(function () {
  return import('@arcblock/did-connect/lib/LoginProtected');
});
var CodeBlock = AsyncComponent(function () {
  return import('../../components/code');
}); // eslint-disable-next-line import/no-cycle

var Embed = AsyncComponent(function () {
  return import('../../components/embed');
});

var GridDiv = function GridDiv(props) {
  return /*#__PURE__*/React.createElement(Grid, Object.assign({
    container: true
  }, props));
};

var GridItem = function GridItem(props) {
  return /*#__PURE__*/React.createElement(Grid, Object.assign({
    item: true
  }, props));
};

var components = {
  countdown: Countdown,
  pre: CodeBlock,
  tag: Tag,
  p: function p(props) {
    return /*#__PURE__*/React.createElement(Typography, Object.assign({
      variant: "body1"
    }, props));
  },
  h2: function h2(props) {
    return /*#__PURE__*/React.createElement(Typography, Object.assign({
      variant: "h3"
    }, props));
  },
  h3: function h3(props) {
    return /*#__PURE__*/React.createElement(Typography, Object.assign({
      variant: "h4"
    }, props));
  },
  h4: function h4(props) {
    return /*#__PURE__*/React.createElement(Typography, Object.assign({
      variant: "h5"
    }, props));
  },
  h5: function h5(props) {
    return /*#__PURE__*/React.createElement(Typography, Object.assign({
      variant: "h5"
    }, props));
  },
  h6: function h6(props) {
    return /*#__PURE__*/React.createElement(Typography, Object.assign({
      variant: "h6"
    }, props));
  },
  embed: Embed,
  badge: Badge,
  alert: Alert,
  video: Video,
  screenshot: function screenshot(props) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'inline-block',
        margin: '0 auto'
      }
    }, /*#__PURE__*/React.createElement(Screenshot, props));
  },
  loginprotected: LoginProtected,
  'click-to-copy': ClickToCopy,
  'wallet-download': WalletDownload,
  'wallet-action': WalletAction,
  'contact-form': ContactForm,
  playgroundaction: PlaygroundAction,
  'action-button': ActionButton,
  'content-icon': ContentIcon,
  'mui-paper': Paper,
  'mui-grid-container': GridDiv,
  'mui-grid-item': GridItem
};
export function getComponents() {
  return components;
}
export function addComponents(_components) {
  if (_components && Object.keys(_components).length) {
    Object.keys(_components).forEach(function (key) {
      components[key] = _components[key];
    });
  }

  return components;
}
export function addComponent(key, component) {
  components[key] = component;
  return components;
}